import { CreateCustomerDto } from "./CreateCustomerDto";

export class CustomerDto extends CreateCustomerDto {
    id: number = 0;
    createdAt: string = '';
    updatedAt: string = '';
}